module.exports = __webpack_public_path__ + "static/media/lumbering30.b1da3818.jpg";